<template>
  <div>
    
    <rfrdetails-tour v-if="$store.state.tour && !loading" />
    
    <transition name="menu-popover">
      <div v-if="pdfPreview" class="lightbox">
        <h2 class="closeX" @click="closeLightbox()">
          <a>&#215;</a>
        </h2>
        <embed
          width="90%"
          height="100%"
          title="If you are having issues viewing this PDF, your browser security settings are set to download PDFs instead of viewing in the browser. You can also try using Chrome instead of Edge."
          :src="'data:application/pdf;base64,' + this.pdfPreview"
        />
      </div>
    </transition>

    <section
      v-if="loading || !rfr"
      class="py-5 pixelsbg bs-shadow mobile-top"
      style="min-height: 178px"
    >
      <div data-v-5a90ec03 class="container">
        <h1 class="text-white mb0 lh1">Loading RFR....</h1>
        <br />
        <div class="hollow-dots-spinner">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </section>

    <section
      v-else
      class="py-5 pixelsbg bs-shadow mobile-top"
      style="min-height: 178px"
    >
      <div class="container">
        <h1 class="text-white mb0 lh1">{{ "RFR #" + rfrId }}</h1>
        <h2 class="text-white lh1"></h2>

        <p
          v-if="rfr"
          class="text-white lh1 mb0"
          v-html="rfr.testRfrs[0].explanation"
        ></p>
      </div>
    </section>

    <div v-if="loading || !rfr" class="row">
      <div class="col-xs-12 col-sm-12 col-12 col-lg-12">
        <div class="flex-box-wrap">
          <div class="flex-internal">
            <atom-spinner
              :animation-duration="1000"
              :size="40"
              :color="'#575757'"
            />
            <p>Loading......</p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="container mt30 mb30">
      <!-- col -->
      <div class="row">
        <div id="rfrdetails-step-1" class="col-lg-8">
          <div class="card-back mb10 rounded bs-shadow p-3">
            <div class="question-header d-flex align-items-center mb5 rounded">
              <div class="d-flex number-showing">

                <!--
                <router-link
                  :to="{ path: $store.state.route.from.fullPath }"
                  class="mb0 lh1 mlauto list-btn dib d-flex center"
                >
                  <i class="material-icons">keyboard_arrow_left</i>
                  Back
                </router-link>
              -->
              <BackButton />
              </div>

              <div v-if="rfr" class="pag-wrapper mlauto">
                <h2>{{ rfr.testRfrs[0].requestReason }}</h2>
              </div>



              
            </div>
            <hr />
            <div class="info-top">
              <div class="top-row d-flex">
                <div v-if="rfr">
                  <h6 style="display: flex; align-items: center;"><span data-v-75905a36="" class="material-icons" style="font-size: 18px; margin-right: 5px;">group</span> Representatives</h6>
                  <p class="text-muted mb5 lh1">
                    <small v-if="rfr.orderDetails.length">
                      {{ rfr.orderDetails[0].salesman }}
                    </small>
                  </p>

                  <!--
                  <p v-for="rep in rfr.itReps" :key="rep.repId" class="text-muted mb5 lh1">
                    <small class="up">
                      {{
                      rep.lastname + ", " + rep.firstname
                      }}
                    </small>
                  </p>
                  -->
                </div>
                <div class="status ml">
                  <p v-if="rfr" class="badge badge-success">
                    {{ rfr.testRfrs[0].status }}
                  </p>
                </div>
              </div>

              <h6 class="mt20" style="display: flex; align-items: center;">
                <span data-v-75905a36="" class="material-icons" style="font-size: 18px; margin-right: 5px;">corporate_fare</span> Area Contractors
              </h6>
              <p class="text-muted mb5 lh1">
                <small v-if="rfr" class="text-muted">
                  {{ rfr.testRfrs[0].acName }}
                </small>
              </p>
              <!--
              <div v-if="rfr">
                <p v-for="ac in rfr.itac" :key="ac.acid" class="text-muted mb5 lh1">
                  <small class="up lh1">{{ ac.acName }}</small>
                </p>
              </div>
              -->
            </div>
            <hr />

            <h6 class="my-0" style="display: flex; align-items: center;"><span data-v-75905a36="" class="material-icons" style="font-size: 18px; margin-right: 5px;">text_snippet</span> Order Number</h6>
            <p class="text-muted mb20">
              <small v-if="rfr" class="up lh1">
                {{ rfr.testRfrs[0].orderNo }}
              </small>
            </p>

            <h6 class="my-0" style="display: flex; align-items: center;">
              <span data-v-75905a36="" class="material-icons" style="font-size: 18px; margin-right: 5px;">text_snippet</span> RFR Explanation
            </h6>
            <p class="text-muted mb20">
              <small v-if="rfr" class="lh1">
                {{ rfr.testRfrs[0].explanation }}
              </small>
            </p>

            <h6 class="my-0" style="display: flex; align-items: center;">
              <span data-v-75905a36="" class="material-icons" style="font-size: 18px; margin-right: 5px;">text_snippet</span> Customer PO Number
            </h6>
            <p class="text-muted mb20">
              <small v-if="rfr.orderDetails.length" class="up lh1">
                {{ rfr.orderDetails[0].customerPoNo }}
              </small>
            </p>
            <hr />

            <h6 class="my-0" style="display: flex; align-items: center;"><span data-v-3c63c41b="" class="material-icons" style="font-size: 18px; margin-right: 5px;">calendar_month</span> Date Requested</h6>
            <p class="text-muted mb20">
              <small v-if="rfr.testRfrs.length" class="up lh1">
                {{ $moment(rfr.testRfrs[0].requested).format("MM-DD-YYYY") }}
              </small>
            </p>

            <h6 class="my-0" style="display: flex; align-items: center;"><span data-v-75905a36="" class="material-icons" style="font-size: 18px; margin-right: 5px;">text_snippet</span> Requestor Name</h6>
            <p class="text-muted mb20">
              <small v-if="rfr.testRfrs.length" class="lh1">
                {{ rfr.testRfrs[0].requestedByUser }}
              </small>
            </p>

            <h6 class="my-0" style="display: flex; align-items: center;">
              <span data-v-75905a36="" class="material-icons" style="font-size: 18px; margin-right: 5px;">text_snippet</span> Requestor Email
            </h6>
            <p class="text-muted mb20">
              <small v-if="rfr.testRfrs.length" class="lh1">
                {{ rfr.testRfrs[0].requestorEmail }}
              </small>
            </p>

            <h6 class="my-0" style="display: flex; align-items: center;">
              <span data-v-75905a36="" class="material-icons" style="font-size: 18px; margin-right: 5px;">text_snippet</span> Requestor Phone
            </h6>
            <p class="text-muted mb20">
              <small v-if="rfr.testRfrs.length" class="up lh1">
                {{ rfr.testRfrs[0].requestorPhone }}
              </small>
            </p>

<!-- NEW CLEAN TABS -->
<div id="rfrdetails-step-3" class="tab-container">
  <!-- Tab Headers -->
  <div class="nav-tabs-custom">
    <button
      :class="{ active: activeTab === 'comments' }"
      @click="activeTab = 'comments'"
      class="tab-button"
    >
      Comments
    </button>
    
    <button
      :class="{ active: activeTab === 'details' }"
      @click="activeTab = 'details'"
      class="tab-button"
    >
      Details
    </button>
  </div>

  <!-- Tab Content -->
  <div class="tab-content-area">
    
    <!-- Comments Tab -->
    <div v-show="activeTab === 'comments'" class="tab-pane">
      <div v-if="rfr && rfr.comment.length">
        <div
          v-for="(comment, index) in rfr.comment"
          :key="index"
          class="comments"
        >
          <div>
            <p class="d-flex mb0">
              <small class="text-muted">
                <i class="fas fa-comment"></i> {{ comment.senderUser }}
              </small>
              <small class="ml text-muted" style="display: flex">
                <i class="material-icons mr2 fs20">schedule</i>
                {{ $moment(comment.dateSent).subtract(1, "minutes").fromNow() }}
              </small>
            </p>
            <h6 class="my-0" style="max-width: 80%">
              {{ comment.message }}
            </h6>
          </div>
        </div>
      </div>
      <h6 v-else class="my-0 text-muted">No Comments Yet</h6>

      <br />
      <div class="form-group">
        <label for="commentTextarea">Add Comment</label>
        <textarea
          v-model="commentString"
          class="form-control"
          id="commentTextarea"
          rows="4"
          placeholder="Type your message here..."
        ></textarea>
      </div>

      <div class="flex-bottom">
        <button
          v-if="!commentString?.trim()"
          disabled
          class="submit-btn"
        >
          Submit
        </button>
        <button
          v-else
          @click.prevent="insertComment()"
          class="submit-btn"
        >
          Submit Comment
        </button>
      </div>
    </div>

    <!-- Details Tab -->
    <div v-show="activeTab === 'details'" class="tab-pane">
      <h5>Requested Charges</h5>
      <table class="table table-striped table-bordered lines-table mb0">
        <thead>
          <tr>
            <th>Hours</th>
            <th>Rate</th>
            <th>Mileage</th>
            <th>Mileage Rate</th>
            <th>Misc</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><small>{{ rfr?.testRfrs[0]?.requestedHours || 0 }}</small></td>
            <td><small>{{ formatPrice(rfr?.testRfrs[0]?.requestedLaborRate) }}</small></td>
            <td><small>{{ rfr?.testRfrs[0]?.requestedMileage || 0 }}</small></td>
            <td><small>{{ formatPrice(rfr?.testRfrs[0]?.mileageRate) }}</small></td>
            <td><small>{{ formatPrice(rfr?.testRfrs[0]?.requestedMisc) }}</small></td>
            <td><strong>{{ formatPrice(calcRequested()) }}</strong></td>
          </tr>
        </tbody>
      </table>

      <hr />

      <h5>Approved Charges</h5>
      <table class="table table-striped table-bordered lines-table mb0">
        <thead>
          <tr>
            <th>Hours</th>
            <th>Rate</th>
            <th>Mileage</th>
            <th>Mileage Rate</th>
            <th>Misc</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><small>{{ rfr?.testRfrs[0]?.approvedHours || 0 }}</small></td>
            <td><small>{{ formatPrice(rfr?.testRfrs[0]?.approvedLaborRate) }}</small></td>
            <td><small>{{ rfr?.testRfrs[0]?.approvedMileage || 0 }}</small></td>
            <td><small>{{ formatPrice(rfr?.testRfrs[0]?.mileageRate) }}</small></td>
            <td><small>{{ formatPrice(rfr?.testRfrs[0]?.approvedMisc) }}</small></td>
            <td><strong>{{ formatPrice(computeApproved) }}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
          </div>
          <div v-if="employee" class="card-back mb10 rounded bs-shadow p-3">
            <div class="edit-notes">
              <div class="top-flex" style="display: flex">
                <h5>
                  <span class="teal">SSC RFR Approval</span>
                </h5>
                <h5 style="margin-left: auto">
                  Total: {{ formatPrice(computeApproved) }}
                </h5>
              </div>
              <p>
                <small
                  >All details need to be filled in to calculate a total. If
                  Misc. is $0, insert 0.</small
                >
              </p>
              <hr />
              <div class="row">
                <div class="col-xs-6 col-md-6 col-6">
                  <div class="form-group mb10">
                    <label for="exampleInputEmail1" class="mb0">Status</label>
                    <select
                      v-if="rfr != null"
                      v-model="rfr.testRfrs[0].status"
                      class="form-control"
                      id="exampleFormControlSelect1"
                    >
                      <!--
                      <option :value="null" selected class="all-contractors">Select a lead carrier</option>
                      -->
                      <option v-for="state in rfrStates" :key="state.id">
                        {{ state.state }}
                      </option>
                    </select>
                  </div>
                  <div v-if="rfr" class="form-group mb10">
                    <label for="exampleInputEmail1" class="mb0">Hours</label>
                    <input
                      type="number"
                      class="form-control"
                      aria-describedby="Hours"
                      placeholder="Enter Hours"
                      v-model="rfr.testRfrs[0].approvedHours"
                      required
                    />
                  </div>
                  <div v-if="rfr" class="form-group mb10">
                    <label for="exampleInputEmail1" class="mb0">Rate</label>
                    <input
                      type="number"
                      class="form-control"
                      aria-describedby="Rate"
                      placeholder="Enter Rate"
                      v-model="rfr.testRfrs[0].approvedLaborRate"
                      required
                    />
                  </div>
                </div>
                <div class="col-xs-6 col-md-6 col-6">
                  <div v-if="rfr" class="form-group mb10">
                    <label for="exampleInputEmail1" class="mb0">Mileage</label>
                    <input
                      type="number"
                      class="form-control"
                      aria-describedby="Mileage"
                      placeholder="Enter Mileage"
                      v-model="rfr.testRfrs[0].approvedMileage"
                      required
                    />
                  </div>
                  <div v-if="rfr" class="form-group mb10">
                    <label for="exampleInputEmail1" class="mb0"
                      >Mileage Rate</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      aria-describedby="Mileage Rate"
                      placeholder="Enter Mileage Rate"
                      v-model="rfr.testRfrs[0].mileageRate"
                      required
                    />
                  </div>

                  <div v-if="rfr" class="form-group mb10">
                    <label for="exampleInputEmail1" class="mb0">Misc</label>
                    <input
                      type="number"
                      class="form-control"
                      aria-describedby="Misc"
                      placeholder="Enter Misc"
                      @change="calcApproved"
                      v-model="rfr.testRfrs[0].approvedMisc"
                      required
                    />
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col col-xs-12 col-12">
                  <div class="flex-bottom">
                    <button
                      @click.prevent="updateRFR"
                      class="
                        mb0
                        lh1
                        mlauto
                        list-btn
                        dib
                        d-flex
                        center
                        router-link-active
                        submit-btn
                      "
                      style="margin-left: auto"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div
            id="rfrdetails-step-2"
            class="card-back mb5 rounded bs-shadow p-3"
          >
            <ul class="list-group mb-3">
              <li
                class="
                  list-group-item
                  d-flex
                  justify-content-between
                  lh-condensed
                "
              >
                <div class>
                  <h6 class="my-0" style="display: flex; align-items: center;">
                    <span data-v-75905a36="" class="material-icons" style="font-size: 18px; margin-right: 5px;">text_snippet</span> Salseforce Case #
                  </h6>

                  <div v-if="rfr.testRfrs[0].salesForce != null">
                    <small class="text-muted">
                      <p class="mb0">
                        {{ rfr.testRfrs[0].salesForce }}
                      </p>
                    </small>
                  </div>
                  <div v-else>
                    <small class="text-muted">
                      <p>Not Available</p>
                    </small>
                  </div>
                </div>
                <!--
                <span class="text-success">-$5</span>
                -->
              </li>
              <li
                class="
                  list-group-item
                  d-flex
                  justify-content-between
                  lh-condensed
                "
              >
                <div class>
                  <h6 class="my-0" style="display: flex; align-items: center;">
                    <span data-v-75905a36="" class="material-icons" style="font-size: 18px; margin-right: 5px;">download</span> Invoice(s)
                  </h6>

                  <div v-if="rfr.invoice.length">
                    <small
                      v-for="invoice in rfr.invoice"
                      :key="invoice.pdfid"
                      class="text-muted"
                    >
                      <p @click="showPDDF(invoice.pdfblog)" class="pdfLink">
                        {{
                          invoice.pdfid +
                          " - " +
                          $moment(invoice.pdfdate).format("MM-DD-YYYY")
                        }}
                      </p>
                    </small>
                  </div>
                  <div v-else>
                    <small class="text-muted">
                      <p>Not Available</p>
                    </small>
                  </div>
                </div>
                <!--
                <span class="text-success">-$5</span>
                -->
              </li>
              <li
                class="
                  list-group-item
                  d-flex
                  justify-content-between
                  lh-condensed
                "
              >
                <div>
                  <div
                    v-if="rfr.attachment.length"
                    class="tab-pane fade show active"
                  >
                    <table
                      class="table table-striped table-bordered lines-table mb0"
                    >
                      <thead>
                        <tr>
                          <th scope="col">Attachments</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="doc in rfr.attachment" :key="doc.id">
                          <th scope="row">
                            <small class="text-muted">
                              
                              <a :href="doc.attachmentFullURL"
                              class="pdfLink"
                                target="_blank"
                                rel="noopener noreferrer"
                                style="cursor: pointer; text-decoration: none; color: #429da8!important;">
                                
                                {{ doc.attachmentName }}
                              </a>
                              <!--
                              
                              <a
                                @click="getDocument(doc.attachmentFullURL)"
                                target="_blank"
                                rel="noopener noreferrer"
                                style="cursor: pointer"
                                >{{ doc.attachmentName }}</a
                              >
                              -->
                              
                            </small>
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <small v-else class="text-muted"
                    >No documents attached.</small
                  >
                  <!--
                  <h6 class="my-0">
                    <i class="fas fa-file-download"></i> Uploads
                  </h6>
                  <small class="text-muted">Brief description</small>
                  -->
                </div>
                <!--
                <span class="text-muted">$12</span>
                -->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
import rfrdetailsTour from "../components/Tours/rfrdetailsTour.vue";
import { formatCurrency } from '../utils/utils';
import BackButton from '@/components/Buttons/BackButton.vue';

const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    //Authorization: "Bearer " + wontworkqwd2iwedjqoewiudwo
  },
};

export default {
  name: "RFRDetails",
  components: {
    AtomSpinner,
    BackButton,
    rfrdetailsTour,
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      server: import.meta.env.VITE_APP_SERVER_URL,
      rfrId: this.$route.params.id,
      userID: this.$store.state.user.UserId,
      rfr: null,
      loading: false,
      processing: false,
      preprod: false,
      inprod: false,
      shipped: false,
      open: "",
      pdfPreview: "",
      commentString: "",
      commentString4Email: "",
      approvedCalc: this.computeApproved,
      activeTab: 'comments',
      rfrStates: [
        {
          id: 1,
          state: "Pending",
        },
        {
          id: 2,
          state: "Needs Approval",
        },
        {
          id: 3,
          state: "Approved",
        },
        {
          id: 4,
          state: "Credit Issued",
        },
        {
          id: 5,
          state: "Denied",
        },
      ],
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.$store.commit("setActivePage", "order-manage");
      //return axios.get(this.endPointCompute, auth).then((response) => {
      return axios
        .get(`${this.ordermanageapi}/rfr/${this.rfrId}`, auth)
        .then((response) => {
          //console.log(response);
          this.rfr = response.data;
          this.loading = false;

          document
            .getElementById("mobileScrollTarget")
            .scrollIntoView({ behavior: "smooth" });

          //console.log(this.rfr.testRfrs[0].approvedMisc);
          //this.calcRequested();

          // check if approved hours is blank
          if (this.rfr && !this.rfr.testRfrs[0].approvedHours) {
            this.rfr.testRfrs[0].approvedHours = this.rfr.testRfrs[0].requestedHours;
          }
          // check if labor rate is blank
          if (this.rfr && !this.rfr.testRfrs[0].approvedLaborRate) {
            this.rfr.testRfrs[0].approvedLaborRate =
              this.rfr.testRfrs[0].requestedLaborRate;
          }
          // check if mileage is blank
          if (this.rfr &&  !this.rfr.testRfrs[0].approvedMileage) {
            this.rfr.testRfrs[0].approvedMileage =
              this.rfr.testRfrs[0].requestedMileage;
          }

          // check if misc is blank
          if (this.rfr && !this.rfr.testRfrs[0].approvedMisc) {
            this.rfr.testRfrs[0].approvedMisc =
              this.rfr.testRfrs[0].requestedMisc;
          }
        });
    },
    formatPrice(amount) {
      return formatCurrency(amount);
    },
    makeActive(item) {
      //console.log(item);
      if (this.open === item) {
        this.open = "";
      } else {
        this.open = item;
      }
    },
    showPDDF(doc) {
      this.pdfPreview = doc;
    },
    closeLightbox() {
      this.pdfPreview = "";
    },

    getDocument(link) {
      //console.log("link: " + link);
      window.open(`http://spacenet2.spacesaver.com/${link}`, "_blank");
    },
    updateRFR() {
      this.$forceUpdate();

      let axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
        },
      };
      let theDATA = [
        {
          op: "replace",
          path: "/status",
          value: this.rfr.testRfrs[0].status,
        },
        {
          op: "replace",
          path: "/approvedHours",
          value: this.rfr.testRfrs[0].approvedHours,
        },
        {
          op: "replace",
          path: "/approvedLaborRate",
          value: this.rfr.testRfrs[0].approvedLaborRate,
        },
        {
          op: "replace",
          path: "/approvedMileage",
          value: this.rfr.testRfrs[0].approvedMileage,
        },
        {
          op: "replace",
          path: "/ApprovedSecondaryTotal",
          value: this.rfr.testRfrs[0].approvedMisc,
        },
        {
          op: "replace",
          path: "/mileageRate",
          value: this.rfr.testRfrs[0].mileageRate,
        },
      ];

      return axios
        .patch(`${this.ordermanageapi}/rfr/${this.rfrId}`, theDATA, axiosConfig)
        .then((response) => {
          console.log(response);
          // this.$noty.success("Successfully updated expedited order!");
          this.$toast.success("Successfully updated expedited order!", { hideProgressBar: false, icon: false });
        })
        .catch((err) => {
          // this.$noty.error("Sorry, there was an issue updating the expedited order");
          this.$toast.error("Sorry, there was an issue updating the expedited order", { hideProgressBar: false, icon: false });
        });
    },
    insertComment() {
      this.commentString4Email = this.commentString;
      var thePostDate = new Date();
      let axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
        },
      };
      let theDATA = {
        parentId: this.rfrId,
        commentType: "RFR",
        senderUserID: this.userID,
        dateSent: thePostDate,
        message: this.commentString,
        subject: `RFR Comment: ${this.rfrId}`,
      };

      let rfrData = {
        rfrNum: this.rfrId,
        name: this.getName,
        emailAddress: this.getEmail,
        comment: this.commentString4Email,
      };

      let customerNotifydata = {
        message: this.commentString4Email,
        sender: this.getName,
        linkID: `rfr-details/${this.rfrId}`,
        notify: this.rfr.testRfrs[0].requestorEmail,
      };

      return axios
        .post(`${this.ordermanageapi}/comments`, theDATA, axiosConfig)
        .then((response) => {
          //console.log(response);
          // this.$noty.success("Successfully added comment!");
          this.$toast.success("Successfully added comment!", { hideProgressBar: false, icon: false });

          //this.rfr.comment.push(theDATA);
          this.commentString = "";
          this.rfr.comment = response.data;
        })
        .then(() => {
          //console.log("Send the comment");
          //if there is no comments and not an employee
          if (!this.employee) {

            //console.log("Sending an email");
            /*
            return axios
              .post(
                `${this.server}/api/v1/rfr-comment-email`,
                rfrData,
                axiosConfig
              )
              .then(() => {
                //console.log(response);
                this.commentString4Email = "";
                this.$noty.success(
                  "Successfully created a new email notification!"
                );
              })
              .catch((err) => {
                //console.log(err);
                this.$noty.error(
                  "Sorry, there was an issue making a new email notification"
                );
              });
              */

          } else {
            //console.log("Send customer email");
            return axios
              .post(
                `${this.server}/api/v1/generic-comment-email`,
                customerNotifydata,
                axiosConfig
              )
              .then(() => {
                //console.log(response);
                this.commentString4Email = "";
                //console.log("Successfully created a new email notification");
                // this.$noty.success("Successfully created a new email notification!");
                this.$toast.success("Successfully created a new email notification!", { hideProgressBar: false, icon: false });

                
              })
              .catch((err) => {
                //console.log(err);
                // this.$noty.error("Sorry, there was an issue making a new email notification");
                this.$toast.success("Sorry, there was an issue making a new email notification", { hideProgressBar: false, icon: false });

              });
          }
        })
        .catch((err) => {
          //console.log(err);
          // this.$noty.error("Sorry, there was an issue posting your comment");
          this.$toast.success("Sorry, there was an issue posting your comment", { hideProgressBar: false, icon: false });

        });
    },
    calcRequested() {
      if (this.rfr != null) {
        let mileage =
          this.rfr.testRfrs[0].requestedMileage *
          this.rfr.testRfrs[0].mileageRate;
        //console.log("mileage " + mileage);
        let hours =
          this.rfr.testRfrs[0].requestedHours *
          this.rfr.testRfrs[0].requestedLaborRate;
        //console.log("hours " + hours);
        let miscR = this.rfr.testRfrs[0].requestedMisc;
        let total = mileage + hours + miscR;
        return total;
      }
    },
    calcApproved() {
      if (this.rfr != null) {
        let mileage =
          this.rfr.testRfrs[0].approvedMileage *
          this.rfr.testRfrs[0].mileageRate;

        //console.log("mileage " + mileage);
        let hours =
          this.rfr.testRfrs[0].approvedHours *
          this.rfr.testRfrs[0].approvedLaborRate;

        //console.log("hours " + hours);
        //rfr.testRfrs[0].approvedMisc
        /*if (this.rfr.testRfrs[0].approvedMisc == "") {
          this.rfr.testRfrs[0].approvedMisc = 0;
        }*/

        let MISCa = this.rfr.testRfrs[0].approvedMisc;

        //console.log("misc " + MISCa);
        let subtotal = mileage + hours + parseFloat(MISCa);
        let total = subtotal;

        return total;
      }
    },
  },
  computed: {
    activeNav() {
      return this.$store.state.activePage;
    },
    computeApproved() {
      if (this.rfr != null) {
        let mileage =
          this.rfr.testRfrs[0].approvedMileage *
          this.rfr.testRfrs[0].mileageRate;
        //console.log("mileage " + mileage);
        let hours =
          this.rfr.testRfrs[0].approvedHours *
          this.rfr.testRfrs[0].approvedLaborRate;
        //console.log("hours " + hours);

        //rfr.testRfrs[0].approvedMisc
        /*if (this.rfr.testRfrs[0].approvedMisc == "") {
          this.rfr.testRfrs[0].approvedMisc = 0;
        }*/

        let MISCa = this.rfr.testRfrs[0].approvedMisc;

        //console.log("misc " + MISCa);
        let subtotal = mileage + hours + parseFloat(MISCa);
        let total = subtotal;

        return total;
      }
    },

    colorGetter() {
      return this.$store.state.colors;
    },

    getUsername() {
      return this.$store.state.user;
    },
    employee() {
      return this.$store.getters.isSpacesaverEmployee;
    },
    getEmail() {
      return this.$store.state.user.Email;
    },
    getName() {
      return (
        this.$store.state.user.FirstName + " " + this.$store.state.user.LastName
      );
    },
    approvedMisc() {
      let finalTotal = this.calcApproved + this.rfr.testRfrs[0].approvedMisc;
      return finalTotal;
    },
  },
  watch: {
    /*
      hours_value: function (newValue) {
          this.rfr.testRfrs[0].approvedHours = -parseInt(newValue);
      },
      rate_value: function (newValue) {
          this.rfr.testRfrs[0].approvedLaborRate = -parseInt(newValue);
      },
      mileage_value: function (newValue) {
          this.rfr.testRfrs[0].approvedMileage = -parseInt(newValue);
      },
      mileage_rate_value: function (newValue) {
          this.rfr.testRfrs[0].mileageRate = -parseInt(newValue);
      },
      misc_value: function (newValue) {
          this.rfr.testRfrs[0].approvedMisc = -parseInt(newValue);
      },
      */
  },
  created() {
    this.$store.commit("showNavigation");

    // console.log(this.$route.path);
  },
  mounted() {
    document
      .getElementById("mobileScrollTarget")
      .scrollIntoView({ behavior: "smooth" });
    this.firstLoad().then(function () {
      //calcProcessing();
      //calcPreProd();
      //calcInProd();
      //calcShipped();
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all and (min-width: 992px) {
  .flex-box-wrap {
    height: 200px;
    padding: 150px 0 125px 0;
    margin: 0;
  }
}

@media all and (max-width: 991px) {
  .flex-box-wrap {
    height: 100px;
    padding: 75px 0 50px 0;
    margin: 0;
    justify-content: center;
    align-items: center;
  }
}
.card-back {
  background: #fff;
}
.article {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.question-bottom {
  align-items: flex-end;
}
.question-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.center {
  align-items: center;
  justify-content: center;
}
.tab-container {
  background: #f2f2f3;
  padding: 10px;
  border-radius: 4px;
}
.nav-tabs {
  border-bottom: none;
}
.nav-tabs .nav-link {
  border: none;
}
#nav-tabContent {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}
.d-flex {
  display: flex;
}
.ml {
  margin-left: auto;
}
/*
.comments:nth-child(even) {
  background: #efefef;
  padding: 10px;
  margin-bottom: 1rem;
  border-radius: 4px;
}
*/
.comments {
  border-bottom: 1px solid #efefef;
  padding: 10px 0;
}
.comments p {
  margin-bottom: 10px;
}
.comments:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.comments:last-child p {
  margin-bottom: 0;
}
.tab-container a {
  color: #429da8;
}
.mt30 {
  margin-top: 30px;
}
.badge {
  display: inline-block;
  padding: 0.5em 0.8em;
}
.progtrckr {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.progtrckr li {
  display: inline-block;
  text-align: center;
  line-height: 3.5em;
}

.progtrckr[data-progtrckr-steps="2"] li {
  width: 25%;
}
.progtrckr[data-progtrckr-steps="3"] li {
  width: 25%;
}
.progtrckr[data-progtrckr-steps="4"] li {
  width: 25%;
}
.progtrckr[data-progtrckr-steps="5"] li {
  width: 25%;
}

.progtrckr li.progtrckr-done {
  color: #fff;
  border-bottom: 4px solid #fff;
}
.progtrckr li.progtrckr-todo {
  color: #3e4651;
  border-bottom: 4px solid #3e4651;
}

.progtrckr li:after {
  content: "\00a0\00a0";
  margin-left: 28px;
  /* this is the text*/
}
.progtrckr li:before {
  position: relative;
  bottom: -2.5em;
  float: left;
  left: calc(50% - 20px);
  line-height: 1em;
}
.progtrckr li.progtrckr-done:before {
  content: "\2713";
  color: #3e4651;
  background-color: #fff;
  height: 40px;
  width: 40px;
  line-height: 40px;
  border: none;
  border-radius: 40px;
}
.progtrckr li.progtrckr-todo:before {
  /*
  content: "\039F";
  color: #fff;
  background-color: #fff;
  font-size: 2.2em;
  bottom: -1.2em;
  */
  content: "\2713";
  color: #3e4651;
  background-color: #3e4651;
  height: 2.2em;
  width: 2.2em;
  line-height: 2.2em;
  border: none;
  border-radius: 2.2em;
}
/* trackker titles */
.tracker-title-wrap {
  margin-top: 15px;
}
.trckr-title {
  padding-left: 0;
}
.trckr-title li {
  display: inline-block;
  text-align: center;
  line-height: 3.5em;
  width: 25%;
  color: #fff;
}
.trckr-title-done {
  color: #fff !important;
}
.trckr-title-todo {
  color: #3e4651 !important;
}
.badge-success {
  color: #fff;
  background-color: #3e4651;
}
@media all and (max-width: 700px) {
  .trckr-title li {
    font-size: 12px;
  }
}
.up {
  text-transform: uppercase;
}
.lines-table td,
.lines-table th {
  padding: 5px;
}
.small,
small {
  font-size: 90% !important;
}

.table td .small,
small {
  font-size: 90% !important;
}
.bol {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  background: #fff;
  padding: 10px;
  list-style-type: none;
  /*border: 1px solid #dee2e6;*/
  background: #efefef;
  margin-bottom: 5px;
  transition: background 0.8s linear;
  border-radius: 4px;
  cursor: pointer;
}
.bol:hover {
  background: #e6e5e5;
}
.parent {
  display: flex;
  align-items: center;
}
.parent i {
  transition: color 0.8s linear;
}
.parent:hover i {
  color: #000;
}
.parent:hover {
  color: #000;
}
.parent:active i {
  color: #00b4b4;
}

.child-list {
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  /*transition: height 0.8s linear;*/
  height: 100%;
  max-height: 100%;
  padding: 5px;
  margin-top: 10px;
  border-radius: 4px;
}
.child-list li {
  position: relative;
  list-style-type: none;
  margin-left: 0;
  border-bottom: 1px solid #dedede;
  padding: 5px;
}
.child-list li:last-of-type {
  border-bottom: none;
}
.is-closed {
  max-height: 0;
}
.show {
  /*height: 100% !important;*/
  max-height: 100% !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.smooth-enter-active,
.smooth-leave-active {
  transition: opacity 0.5s;
  height: auto;
}
.smooth-enter,
.smooth-leave-to {
  opacity: 0;
}

.height-enter-active,
.height-leave-active {
  transition: height 0.5s;
  height: auto;
}
.height-enter,
.height-leave-to {
  height: 0;
}
.ship-head {
  display: flex;
  width: 100%;
}
.pallet {
  width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ship-number {
  width: calc(50% + 3px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media all and (max-width: 700px) {
  .pallet {
    width: 60%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ship-number {
    width: calc(60% + 3px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.fa-arrow-circle-down {
  margin-left: auto;
}

.w100 {
  width: 100%;
}
.dflex {
  display: flex;
}
.info {
  border-top: 1px solid #dedede;
  padding-top: 5px;
  margin-top: 5px;
}
.truck-no {
  margin-left: -5px;
}
.closeX {
  top: 0;
}
.pdfLink {
  color: #429da8;
  cursor: pointer;
  margin-bottom: 0;
}
.pdfLink:hover {
  color: #00b4b4;
}
.pdfLink:active {
  color: #00b4b4;
}
.lightbox {
  z-index: 10003 !important;
}
.flex-bottom {
  display: flex;
}
.submit-btn {
  border: none !important;
  padding: 7px 12px;
}
button:disabled {
  background: rgba(0, 0, 0, 0.2) !important;
  border: none !important;
}
.list-btn {
  border: none !important;
}

.tab-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-top: 15px;
}

.nav-tabs-custom {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  border-bottom: 2px solid #e5e7eb;
}

.tab-button {
  padding: 14px 28px;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.2s ease;
}

.tab-button.active {
  color: #00b4b4;
  border-bottom: 3px solid #00b4b4;
  background: white;
  border-radius: 6px 6px 0 0;
}

.tab-content-area {
  background: white;
  padding: 25px;
  border-radius: 6px;
  min-height: 320px;
}

.tab-pane {
  display: block;
}

.submit-btn {
  background: #00b4b4;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: 500;
}
.pixelsbg {
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23505a65'/%3E%3Cstop offset='1' stop-color='%23505a65' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233f474f'/%3E%3Cstop offset='1' stop-color='%233f474f' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23383e45'/%3E%3Cstop offset='1' stop-color='%23383e45' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%23474f58' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%23464f58' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%23464e57' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%23454e56' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23454d56' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%23444d55' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%23444c55' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%23434b54' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%23434b53' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23424a53' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23424a52' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23404850' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23404750' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%233f474f' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%233e454d' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%233e454c' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%233d444c' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%233d444b' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%233c434b' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%233c424a' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%233b4249' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%233b4149' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%233a4148' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%233a4047' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%23394047' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%23393f46' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%23383f46' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%23394047' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%233b4148' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%233c434a' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%233d444c' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%233f464e' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%2340474f' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23414951' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23434a53' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23444c55' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%23454d57' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%23474f58' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%2348515a' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%2349525c' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%234b545e' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%234c5560' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%234d5761' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%234f5963' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%23505a65' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%23515c67' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%23535d69' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%23545f6b' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2355616c' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2357626e' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%23586470' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%235a6672' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%235b6774' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%235c6976' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b78' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%235f6c7a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23616e7c' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%2362707d' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%2363717f' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23657381' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23667583' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23687685' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525b' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c555f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5660' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234d5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234e5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%234f5a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23505b65' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%23545f6a' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355606c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356616d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636e' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6773' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235c6976' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235d6a77' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%235f6d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23606e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23616f7c' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647280' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657382' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%23383e45' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='.5'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233c768a'/%3E%3Cstop offset='1' stop-color='%233c768a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23305e6e'/%3E%3Cstop offset='1' stop-color='%23305e6e' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%2346505a' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%2344515c' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%2343515d' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%2341525e' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23405260' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%233e5361' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%233d5462' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%233c5463' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%233a5565' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23395666' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23375767' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23365969' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23345a6a' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23335b6b' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23325d6c' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%23305e6e' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%232f606f' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%232d6170' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%232c6372' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%232b6573' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%23296774' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%23286975' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%23266b77' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%23256d78' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%23246f79' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%2322727a' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%2321747c' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%2320767d' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%231e797e' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%231d7c80' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%231b7e81' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%231c8083' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%231d8083' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%231f7f84' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%23217e85' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%23227e85' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%23247d86' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23267c87' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23287c87' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23297b88' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%232b7a88' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%232d7a88' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%232f7989' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%23317989' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%23337889' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%2335788a' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%2337778a' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%233a778a' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%233c768a' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%233e768a' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%2340758a' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%2343758a' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2345758a' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2347758a' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%234a758a' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%234c748a' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%234e748a' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%2351748a' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%2354758a' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%2356758a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23597589' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%235b7589' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%235e7689' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23617688' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23637788' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23667787' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525c' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c565f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5761' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234e5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234f5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%23505a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23515b66' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%2354606b' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355616c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356626d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636f' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6774' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235d6a76' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235e6b78' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235f6c79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%23606d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23616e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23626f7d' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647281' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657482' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%231a8182' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='0.79'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
</style>
